import { Quote, Forward } from "lucide-react";
import { ReactionPopup } from "../ReactionPopup";
import { MessageActionMenu } from "../MessageActionMenu";

const ICON_BUTTON_CLASS =
  "flex items-center justify-center h-6 w-6 rounded-full bg-white text-gray-500 shadow-sm ring-1 ring-black/5 hover:bg-gray-50 hover:text-gray-700 active:bg-gray-100 transition-colors duration-150 focus-visible:ring-2 focus-visible:ring-blue-400/40 focus-visible:outline-none";

export function MessageActionsBar({
  shop,
  msg,
  isGroup,
  isSelf,
  isPinned,
  onPinChange,
  staffName,
  onReply,
  onForward,
  onReactionApplied,
  showReaction = true,
  alignEnd = true,
}) {
  return (
    <div
      className={`flex items-center gap-1 ${
        alignEnd ? "justify-end" : "justify-start"
      }`}
    >
      {showReaction && (
        <ReactionPopup
          shop={shop}
          msg={msg}
          isGroup={isGroup}
          onReactionApplied={onReactionApplied}
        />
      )}
      <button
        type="button"
        onClick={onReply}
        className={ICON_BUTTON_CLASS}
        title="Trả lời"
        aria-label="Trả lời"
      >
        <Quote className="h-3 w-3" />
      </button>
      <button
        type="button"
        onClick={onForward}
        className={ICON_BUTTON_CLASS}
        title="Chuyển tiếp"
        aria-label="Chuyển tiếp"
      >
        <Forward className="h-3 w-3" />
      </button>
      <MessageActionMenu
        shop={shop}
        msg={msg}
        isGroup={isGroup}
        isSelf={isSelf}
        isPinned={isPinned}
        onPinChange={onPinChange}
        staffName={staffName}
      />
    </div>
  );
}
